
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Credencias } from '../models/credencias.model';
import { LoginComponent } from '../pages/login/login.component';
import { environment } from '../../environments/environment';
import { Eleitor } from '../models/eleitor.model';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Aprovador } from '../models/aprovador.model';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  loginParticipante: LoginComponent;
  configHeader: { headers: { Authorization: any; }; };
  constructor(
    private http: HttpClient,
    private recaptchaV3Service: ReCaptchaV3Service
  ) { }

  public authenticateLoginEleitor(creds: Credencias, eleicao: any) {
    return this.http.post(`${environment.url_api}/auth/eleitor-login?rotaEleicao=${eleicao}`, creds)
  }
  public authenticateLoginAprovador(creds: Credencias, eleicao: any) {
    return this.http.post(`${environment.url_api}/auth/aprovador-login?rotaEleicao=${eleicao}`, creds)
  }
  public authenticateLoginGestor(creds: Credencias) {
    return this.http.post(`${environment.url_api}/auth/gestor-login`, creds)
  }

  public authenticateLoginPreview(creds: Credencias) {
    return this.http.post(`${environment.url_api}/auth/gestor-email-login`, creds)
  }

  public authenticateLoginAssistente(creds: Credencias) {
    return this.http.post(`${environment.url_api}/auth/assistente-login`, creds)
  }

  public authenticateLoginAdmin(creds: Credencias) {
    return this.http.post(`${environment.url_api}/auth/administrador-login`, creds)
  }

  public authenticateAcessoPrecandidato(informacoesPreCandidato: String, eleicao: any) {
    return this.http.post(`${environment.url_api}/auth/precandidato-acesso?rotaEleicao=${eleicao}`, informacoesPreCandidato)
  }

  public authenticateAcessoEleitorIntegracao(informacoesPreCandidato: String, eleicao: any) {
    return this.http.post(`${environment.url_api}/auth/eleitor-integracao-login?rotaEleicao=${eleicao}`, informacoesPreCandidato)
  }

  public decodificarTokenIntegracao(token: String) {
    return this.http.post(`${environment.url_api}/auth/token-integracao`, token)
  }

  public async validarTokenCaptchaService(token: string, tipoCaptcha:string) {
    return new Promise((resolve, reject) => {
        this.http.post(`${environment.url_api}/auth/recap-google?tipoCaptcha=`+ tipoCaptcha + `&token=` + token, null).subscribe(
          payload => {
            resolve(payload)
          },
          (err) => {
            reject(err.error);
          }
        )
    })
  }

  public getParticipantePorLogin(token: string) {
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.get<Eleitor>(`${environment.url_api}/eleitor/self`, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        },
        (err) => {
          reject(err.error);
        }
      )
    })
  }

  public getEleitorRedefinirSenha(token: string) {
    console.log(token)
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.get<Eleitor>(`${environment.url_api}/eleitor/self-redefinir-senha`, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        },
        (err) => {
          reject(err.error);
        }
      )
    })
  }

  public getRedefinirSenhaAprovador(token: string) {
    console.log(token)
    return new Promise((resolve, reject) => {
      this.configHeader = { headers: { 'Authorization': token } },
      this.http.get<Aprovador>(`${environment.url_api}/aprovadores/self-redefinir-senha`, this.configHeader).subscribe(
        payload => {
          resolve(payload)
        },
        (err) => {
          reject(err.error);
        }
      )
    })
  }

}
